<template>
	<div class="Modal">
		<div class="form-control">
			<select v-model="formData.reason">
				<option selected disabled value="">Reden van het afbreken van de uitvoering</option>
				<option v-for="reason in reasons" :key="reason" :value="reason">{{ reason }}</option>
			</select>
			<span v-if="formErrors.includes('reason')" class="form-error">Reden mag niet leeg zijn</span>
		</div>
		<div class="form-control">
			<textarea
				v-model="formData.description"
				rows="4"
				placeholder="Omschrijving van de support ticket"
			></textarea>
			<span v-if="formErrors.includes('description')" class="form-error">Omschrijving mag niet leeg
				zijn
			</span>
		</div>
		<div class="form-control">
			<div class="files">
				<div class="image-container" @click="$refs.uploadInput0 ? $refs.uploadInput0.click() : null">
					<loading-indicator
						v-if="pendingFile1 != null && pendingFile1.state === 'uploading'" class="loader"
					></loading-indicator>
					<img
						v-if="pendingFile1 != null"
						class="pending-upload"
						:src="pendingFile1.getThumbnail()"
					>
					<image-icon class="placeholder" v-if="pendingFile1 == null"></image-icon>
					<input
						class="upload-input"
						type="file"
						:multiple="false"
						@change="addFile($event.target.files, 0)"
						ref="uploadInput0"
						:accept="accept"
					>
				</div>
				<div class="image-container" @click="$refs.uploadInput1 ? $refs.uploadInput1.click() : null">
					<loading-indicator
						v-if="pendingFile2 != null && pendingFile2.state === 'uploading'" class="loader"
					></loading-indicator>
					<img
						v-if="pendingFile2 != null"
						class="pending-upload"
						:src="pendingFile2.getThumbnail()"
					>
					<image-icon class="placeholder" v-if="pendingFile1 == null"></image-icon>
					<input
						class="upload-input"
						type="file"
						:multiple="false"
						@change="addFile($event.target.files, 1)"
						ref="uploadInput1"
						:accept="accept"
					>
				</div>

			</div>
			<span v-if="formErrors.includes('files')" class="form-error">Foto's mogen niet leeg zijn</span>
		</div>
		<button type="button" @click="save">Volgende</button>
	</div>
</template>

<script>
import {QueuedFile} from "@/common/queued-file";
import LoadingIndicator from "@/components/LoadingIndicator.vue";
import {client} from "@/store";
import {ImageIcon} from "vue-feather-icons";

export default {

	components: {
		LoadingIndicator,
		ImageIcon
	},

	props: {
		appointment: Object
	},

	data() {
		return {
			formData: {
				reason: "",
				description: ""
			},
			formErrors: [],
			spouwisolatieReasons: [
				"Airconditioning niet afgepurt",
				"Gedeelte niet bereikbaar",
				"Gevels niet vrij van begroeiing",
				"Hoogwerker/steiger niet aanwezig",
				"Geen hoogwerker/steiger in de opdracht",
				"Verkeerde hoogwerker/steiger beschikbaar",
				"Houten skelet bouw",
				"Klant is niet aanwezig",
				"Problemen met product/materiaal/apparatuur",
				"Scheuren/slecht voegwerk/stenen los",
				"Schoonmetselwerk",
				"Spouwvervuiling",
				"Te smalle voeg",
				"Te weinig materiaal mee",
				"Te weinig tijd",
				"Weersomstandigheden",
				"Anders"
			],
			vloerisolatieReasons: [
				"Doorgang naar ander compartiment te klein",
				"Geen doorgang naar andere compartiment",
				"Kruipluik te klein",
				"Kruipruimte te laag",
				"Kwaitaailvloer",
				"Lekkage in de kruipruimte",
				"Niet juiste materiaal voorhanden",
				"Te veel leidingen & kabels",
				"Te veel puin in kruipruimte",
				"Te veel water in kruipruimte",
				"Te veel werk voor één dag",
				"Te weinig materiaal mee",
				"Anders"
			],
			bodemisolatieReasons: [
				"Doorgang naar ander compartiment te klein",
				"Geen doorgang naar andere compartiment",
				"Kruipluik te klein",
				"Kruipruimte te laag",
				"Te veel leidingen & kabels",
				"Te veel puin in kruipruimte",
				"Te veel water in kruipruimte",
				"Anders"
			],
			reasons: [],
			pendingFile1: null,
			pendingFile2: null,
			accept: {
				type: String,
				default: "img/*"
			}
		};
	},

	beforeMount() {
	},

	mounted() {
		switch (this.appointment.project.gripp_projectphase_id) {
			case 35:
				this.reasons = this.bodemisolatieReasons;
				break;
			case 55:
			case 58:
				this.reasons = this.vloerisolatieReasons;
				break;
			case 28:
			case 54:
			default:
				this.reasons = this.spouwisolatieReasons;
				break;
		}
	},

	computed: {},

	methods: {
		addFile(files, index) {
			if (files.length > 0) {
				if (index === 0) {
					this.pendingFile1 = new QueuedFile(
						files[0],
						"support/afgebroken",
						this.appointment.company.id,
						this.$forceUpdate
					);
				} else {
					this.pendingFile2 = new QueuedFile(
						files[0],
						"support/afgebroken",
						this.appointment.company.id,
						this.$forceUpdate
					);
				}
				this.$forceUpdate();
			}
			this.$refs["uploadInput" + index].value = "";
		},

		save() {
			this.formErrors = [];
			if (this.empty(this.formData.reason) || this.empty(this.formData.description) || this.pendingFile1 == null || this.pendingFile2 == null) {
				if (this.empty(this.formData.reason)) {
					this.formErrors.push("reason");
				}
				if (this.empty(this.formData.description)) {
					this.formErrors.push("description");
				}
				if (this.pendingFile1 == null || this.pendingFile2 == null) {
					this.formErrors.push("files");
				}
				return;
			}
			Promise.all([this.pendingFile1.upload(), this.pendingFile2.upload()])
				.then(() => {
					this.performSave();
				})
				.catch((error) => {
					this.$notify({
						group: "app",
						title: "Opslaan mislukt",
						type: "error",
						text: `Er is een fout opgetreden bij het opslaan.`
					});
					console.error(error);
				});
		},

		performSave() {
			client.query(`mutation($id: ID!, $reason: String!, $remark: String!) {
					        stopExecutingAppointment(id: $id, reason: $reason, remark: $remark)
                        }`, {
				id: this.appointment.id,
				reason: this.formData.reason,
				remark: this.formData.description
			}).then(result => {
				if (result.stopExecutingAppointment === 'SUCCESS') {
					this.$notify({
						group: "app",
						title: "Opslaan gelukt",
						type: "success",
						text: `De afspraak is afgebroken`
					});
					this.$router.push("/uitvoering-afspraken");
					this.$emit('close');
				}
				if (result.stopExecutingAppointment === 'ALREADY_STOPPED') {
					this.$notify({
						group: "app",
						title: "Afspraak al afgebroken",
						type: "success",
						text: `De afspraak was al afgebroken`
					});
					this.$router.push("/uitvoering-afspraken");
					this.$emit('close');
				}
			}).catch(error => {
				this.$notify({
					group: "app",
					title: "Opslaan mislukt",
					type: "error",
					text: `Er is een fout opgetreden bij het afbreken van de afspraak.`
				});
			});
		},

		empty(value) {
			return value == null || (typeof value === "string" && value.trim() === "");
		}

	}
};
</script>

<style scoped lang="scss">
.Modal {
	display: flex;
	flex-direction: column;
	padding-top: 20px;
	gap: 20px;

	.files {
		display: flex;
		flex-direction: row;
		gap: 16px;
	}

	.form-control {
		> input, > select, > textarea, ::v-deep > .DateField .DateField__group .TextField {
			border: 2px solid #ced6dd;
			border-radius: 5px;
			box-shadow: none;
			margin: 0 0 8px 0;
			padding: 0.5em;
			background: #ffffff;
			font-size: 1rem;
			width: 100%;
			box-sizing: border-box;
		}

		.form-error {
			color: #e53935;
		}

	}

	button {
		align-self: flex-end;
		margin: 8px 0 8px auto;
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
		padding: 5px 16px;
		background-color: #35a5a4;
		color: white;
		border: none;
		border-radius: 4px;
		font-weight: bold;
		height: 36px;
		min-width: 130px;
	}
}

.image-container {
	aspect-ratio: 16/9;
	border: 2px solid #eeeeee;
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	background: #ffffff;
	margin: 0 auto;
	width: 100%;

	.placeholder {
		height: 48px;
		width: 48px;
		color: #ced6dd;
	}

	label {
		font-size: 2rem;
	}

	.loader {
		z-index: 2;
		width: 50%;
		height: 50%;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
	}

	img {
		position: absolute;
		height: 100%;
		width: 100%;
		object-fit: cover;

		&.pending-upload {
			filter: contrast(0.5);
		}
	}

	input {
		display: none;
	}
}
</style>
